module.exports = __webpack_public_path__ + "media/images/return-icon-ae2f3a2837e402fdbb43aaa81237c0c9.svg";